import { Module } from 'vuex';
import { UnsavedChangesGuardState } from './types/unsavedChangesGuard.types';
import { RootState } from '@/store/store';
import state from './unsavedChangesGuard.state';
import mutations from './unsavedChangesGuard.mutations';
import actions from './unsavedChangesGuard.actions';

const unsavedChangesGuardModule: Module<UnsavedChangesGuardState, RootState> = {
  /**
   * Enable namespacing for this module.
   * This means actions, mutations, and getters within this module will be accessed using the module's registered name as a prefix (e.g. 'unsavedChangesGuard/SET_MODAL_ACTIVE').
   */
  namespaced: true,
  state,
  mutations,
  actions,
};

export default unsavedChangesGuardModule;
